import { delay, http, HttpResponse } from 'msw'
import { InvoiceQueryResponseRecord } from '../app/core/interfaces/invoice.interface';

// @ts-ignore
if (typeof window['mocks'] === 'undefined') {
  // @ts-ignore
  window['mocks'] = [];
}

const invoices: InvoiceQueryResponseRecord[] = [
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162414",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-09",
    "netAmount": -771.85,
    "currency": "EUR",
    "totalAmount": -933.94,
    "vatAmount": -162.09,
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162412",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-09",
    "netAmount": -79177.37,
    "currency": "EUR",
    "totalAmount": -79177.37,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162404",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-04",
    "netAmount": -9116.14,
    "currency": "EUR",
    "totalAmount": -11030.53,
    "vatAmount": -1914.39
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162403",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-04",
    "netAmount": -9310.94,
    "currency": "EUR",
    "totalAmount": -11266.24,
    "vatAmount": -1955.3
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162402",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-04",
    "netAmount": -2909.68,
    "currency": "EUR",
    "totalAmount": -3520.71,
    "vatAmount": -611.03
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162401",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-04",
    "netAmount": -2828.75,
    "currency": "EUR",
    "totalAmount": -3422.79,
    "vatAmount": -594.04
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162400",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-03",
    "netAmount": -6.0,
    "currency": "EUR",
    "totalAmount": -7.26,
    "vatAmount": -1.26
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162399",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-10-03",
    "netAmount": -472.2,
    "currency": "EUR",
    "totalAmount": -472.2,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082484",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 2421.35,
    "currency": "EUR",
    "totalAmount": 2929.83,
    "vatAmount": 508.48
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082479",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 178592.1,
    "currency": "EUR",
    "totalAmount": 216096.44,
    "vatAmount": 37504.34
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082478",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 4649.4,
    "currency": "EUR",
    "totalAmount": 5625.77,
    "vatAmount": 976.37
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082477",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 513700.3,
    "currency": "EUR",
    "totalAmount": 621577.36,
    "vatAmount": 107877.06
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082243",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 2527794.62,
    "currency": "EUR",
    "totalAmount": 2527794.62,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082242",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": 38933.44,
    "currency": "EUR",
    "totalAmount": 38933.44,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161979",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -149847.31,
    "currency": "EUR",
    "totalAmount": -149847.31,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161980",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -4485.2,
    "currency": "EUR",
    "totalAmount": -5427.09,
    "vatAmount": -941.89
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161981",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -1455902.79,
    "currency": "EUR",
    "totalAmount": -1455902.79,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161982",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -3735.16,
    "currency": "EUR",
    "totalAmount": -3735.16,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161983",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -1888.8,
    "currency": "EUR",
    "totalAmount": -1888.8,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161984",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -45770.24,
    "currency": "EUR",
    "totalAmount": -45770.24,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161985",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -13560.08,
    "currency": "EUR",
    "totalAmount": -13560.08,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162319",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -2225.68,
    "currency": "EUR",
    "totalAmount": -2693.07,
    "vatAmount": -467.39
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162320",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -2.39,
    "currency": "EUR",
    "totalAmount": -2.89,
    "vatAmount": -0.5
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162321",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -46.8,
    "currency": "EUR",
    "totalAmount": -56.63,
    "vatAmount": -9.83
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162322",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -12.25,
    "currency": "EUR",
    "totalAmount": -14.82,
    "vatAmount": -2.57
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162323",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -117922.89,
    "currency": "EUR",
    "totalAmount": -142686.7,
    "vatAmount": -24763.81
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162324",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -2387.2,
    "currency": "EUR",
    "totalAmount": -2888.51,
    "vatAmount": -501.31
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162325",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -6891.01,
    "currency": "EUR",
    "totalAmount": -8338.12,
    "vatAmount": -1447.11
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055162326",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-30",
    "netAmount": -14132.21,
    "currency": "EUR",
    "totalAmount": -17099.97,
    "vatAmount": -2967.76
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161919",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-29",
    "netAmount": 0.0,
    "currency": "EUR",
    "totalAmount": 0.0,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081936",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 8337.6,
    "currency": "EUR",
    "totalAmount": 8337.6,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081937",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 2227743.77,
    "currency": "EUR",
    "totalAmount": 2227743.77,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082151",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 378863.63,
    "currency": "EUR",
    "totalAmount": 458424.99,
    "vatAmount": 79561.36
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082152",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 4949.28,
    "currency": "EUR",
    "totalAmount": 5988.63,
    "vatAmount": 1039.35
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082153",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 137600.92,
    "currency": "EUR",
    "totalAmount": 166497.11,
    "vatAmount": 28896.19
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050082159",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": 3191.76,
    "currency": "EUR",
    "totalAmount": 3862.03,
    "vatAmount": 670.27
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161344",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -130606.89,
    "currency": "EUR",
    "totalAmount": -130606.89,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161345",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -1256447.02,
    "currency": "EUR",
    "totalAmount": -1256447.02,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161346",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -24871.04,
    "currency": "EUR",
    "totalAmount": -24871.04,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161816",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -6744.62,
    "currency": "EUR",
    "totalAmount": -8160.99,
    "vatAmount": -1416.37
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161815",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -7200.59,
    "currency": "EUR",
    "totalAmount": -8712.71,
    "vatAmount": -1512.12
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161814",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -2250.2,
    "currency": "EUR",
    "totalAmount": -2722.74,
    "vatAmount": -472.54
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161813",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -2084.73,
    "currency": "EUR",
    "totalAmount": -2522.52,
    "vatAmount": -437.79
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161749",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -12228.54,
    "currency": "EUR",
    "totalAmount": -14796.53,
    "vatAmount": -2567.99
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161748",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -5152.81,
    "currency": "EUR",
    "totalAmount": -6234.9,
    "vatAmount": -1082.09
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161747",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -1991.4,
    "currency": "EUR",
    "totalAmount": -2409.59,
    "vatAmount": -418.19
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161746",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -73458.11,
    "currency": "EUR",
    "totalAmount": -88884.31,
    "vatAmount": -15426.2
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161745",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -10.2,
    "currency": "EUR",
    "totalAmount": -12.34,
    "vatAmount": -2.14
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161744",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -25.2,
    "currency": "EUR",
    "totalAmount": -30.49,
    "vatAmount": -5.29
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161743",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -2.12,
    "currency": "EUR",
    "totalAmount": -2.57,
    "vatAmount": -0.45
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161742",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -1512.63,
    "currency": "EUR",
    "totalAmount": -1830.28,
    "vatAmount": -317.65
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161347",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -4222.8,
    "currency": "EUR",
    "totalAmount": -4222.8,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161348",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-11",
    "netAmount": -11667.4,
    "currency": "EUR",
    "totalAmount": -11667.4,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081742",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 47250.0,
    "currency": "EUR",
    "totalAmount": 47250.0,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081743",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 5949.0,
    "currency": "EUR",
    "totalAmount": 5949.0,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081744",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 7398.0,
    "currency": "EUR",
    "totalAmount": 7398.0,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081774",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 15131.2,
    "currency": "EUR",
    "totalAmount": 15131.2,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081775",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 655139.69,
    "currency": "EUR",
    "totalAmount": 655139.69,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081843",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 141671.36,
    "currency": "EUR",
    "totalAmount": 171422.35,
    "vatAmount": 29750.99
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081844",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 34722.86,
    "currency": "EUR",
    "totalAmount": 42014.66,
    "vatAmount": 7291.8
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081848",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": 1077.06,
    "currency": "EUR",
    "totalAmount": 1303.24,
    "vatAmount": 226.18
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161060",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -1.1,
    "currency": "EUR",
    "totalAmount": -1.33,
    "vatAmount": -0.23
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161059",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -550.32,
    "currency": "EUR",
    "totalAmount": -665.89,
    "vatAmount": -115.57
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161107",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -6728.09,
    "currency": "EUR",
    "totalAmount": -8140.99,
    "vatAmount": -1412.9
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161106",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -7051.62,
    "currency": "EUR",
    "totalAmount": -8532.46,
    "vatAmount": -1480.84
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161105",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -2203.67,
    "currency": "EUR",
    "totalAmount": -2666.44,
    "vatAmount": -462.77
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161104",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -2072.6,
    "currency": "EUR",
    "totalAmount": -2507.85,
    "vatAmount": -435.25
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161066",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -2964.11,
    "currency": "EUR",
    "totalAmount": -3586.57,
    "vatAmount": -622.46
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161065",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -2311.09,
    "currency": "EUR",
    "totalAmount": -2796.42,
    "vatAmount": -485.33
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161064",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -1070.33,
    "currency": "EUR",
    "totalAmount": -1295.1,
    "vatAmount": -224.77
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161063",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -26702.44,
    "currency": "EUR",
    "totalAmount": -32309.95,
    "vatAmount": -5607.51
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161062",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -5.5,
    "currency": "EUR",
    "totalAmount": -6.66,
    "vatAmount": -1.16
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055161061",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -14.4,
    "currency": "EUR",
    "totalAmount": -17.42,
    "vatAmount": -3.02
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160860",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -28135.66,
    "currency": "EUR",
    "totalAmount": -28135.66,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160861",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -316861.34,
    "currency": "EUR",
    "totalAmount": -316861.34,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160862",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-09-04",
    "netAmount": -17344.12,
    "currency": "EUR",
    "totalAmount": -17344.12,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081732",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 1962.98,
    "currency": "EUR",
    "totalAmount": 2375.21,
    "vatAmount": 412.23
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081728",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 102172.92,
    "currency": "EUR",
    "totalAmount": 123629.23,
    "vatAmount": 21456.31
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081727",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 2550.24,
    "currency": "EUR",
    "totalAmount": 3085.79,
    "vatAmount": 535.55
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081726",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 235236.73,
    "currency": "EUR",
    "totalAmount": 284636.44,
    "vatAmount": 49399.71
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081531",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 25052.8,
    "currency": "EUR",
    "totalAmount": 25052.8,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9050081530",
    "invoiceType": "IN",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": 1733311.52,
    "currency": "EUR",
    "totalAmount": 1733311.52,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160738",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -9547.82,
    "currency": "EUR",
    "totalAmount": -11552.86,
    "vatAmount": -2005.04
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160737",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -7599.05,
    "currency": "EUR",
    "totalAmount": -9194.85,
    "vatAmount": -1595.8
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160736",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -1820.5,
    "currency": "EUR",
    "totalAmount": -2202.81,
    "vatAmount": -382.31
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160735",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -44967.08,
    "currency": "EUR",
    "totalAmount": -54410.17,
    "vatAmount": -9443.09
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160734",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -5.9,
    "currency": "EUR",
    "totalAmount": -7.14,
    "vatAmount": -1.24
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160733",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -12.24,
    "currency": "EUR",
    "totalAmount": -14.81,
    "vatAmount": -2.57
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160732",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -1.0,
    "currency": "EUR",
    "totalAmount": -1.21,
    "vatAmount": -0.21
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160731",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -1182.71,
    "currency": "EUR",
    "totalAmount": -1431.08,
    "vatAmount": -248.37
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160463",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -11833.38,
    "currency": "EUR",
    "totalAmount": -11833.38,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160462",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -15500.36,
    "currency": "EUR",
    "totalAmount": -15500.36,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160461",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -1011110.38,
    "currency": "EUR",
    "totalAmount": -1011110.38,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160460",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-31",
    "netAmount": -111859.44,
    "currency": "EUR",
    "totalAmount": -111859.44,
    "vatAmount": 0.0
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160335",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -7021.14,
    "currency": "EUR",
    "totalAmount": -8495.58,
    "vatAmount": -1474.44
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160334",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -8408.53,
    "currency": "EUR",
    "totalAmount": -10174.32,
    "vatAmount": -1765.79
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160333",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -2627.71,
    "currency": "EUR",
    "totalAmount": -3179.53,
    "vatAmount": -551.82
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160332",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -2172.96,
    "currency": "EUR",
    "totalAmount": -2629.28,
    "vatAmount": -456.32
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160275",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -13192.35,
    "currency": "EUR",
    "totalAmount": -15962.74,
    "vatAmount": -2770.39
  },
  {
    "eSoftId": "0002001853",
    "soldToId": "0001000960",

    "invoiceNumber": "9055160274",
    "invoiceType": "CR",
    "source": "mock",
    "invoiceDate": "2023-08-28",
    "netAmount": -7724.11,
    "currency": "EUR",
    "totalAmount": -9346.17,
    "vatAmount": -1622.06
  }
];

// @ts-ignore
window['mocks'].push(
  http.post('api/Invoice/query', async ({request}) => {
    const requestBody: any = await request.json();

    // filtering
    const filteredInvoices = invoices.filter(invoice => {
      if (requestBody.invoiceNumber) {
        return invoice.invoiceNumber.indexOf(requestBody.invoiceNumber) >= 0;
      }
      return true;
    });

    // sorting
    filteredInvoices.sort((invoice1, invoice2) => {
      let result = 0;
      switch (requestBody.sortingColumn) {
        case 'invoiceNumber':
        case 'invoiceNo':
          result = invoice1.invoiceNumber.localeCompare(invoice2.invoiceNumber);
          break;
        case 'currency':
          result = invoice1.currency.localeCompare(invoice2.currency);
          break;
        case 'netAmount':
          result = invoice1.netAmount - invoice2.netAmount;
          break;
        case 'vatAmount':
          result = invoice1.vatAmount - invoice2.vatAmount;
          break;
        case 'totalAmount':
          result = invoice1.totalAmount - invoice2.totalAmount;
          break;
        case 'invoiceDate':
          result = invoice1.invoiceDate.localeCompare(invoice2.invoiceDate);
          break;
      }
      return requestBody.sortingType === 'ASC' ? result : -1 * result;
    });
    // paging
    const pageNumber = requestBody.pageNumber;
    const pageSize = requestBody.pageSize;
    const pagedInvoices = filteredInvoices.filter((invoice, index) => {
      if (!pageSize) {
        return true;
      }
      return (index >= ((pageNumber - 1) * pageSize) && index < pageNumber * pageSize);
    });
    const result = {
      items: pagedInvoices,
      totalItems: filteredInvoices.length,
    }
    await delay(500);
    return HttpResponse.json(result);
  }),

  http.post('api/Invoice/listInvoicesAsDocument', async () => {
    const buffer = await fetch('/mocks/invoices.xlsx').then(response => response.arrayBuffer());
    await delay(1000);
    return HttpResponse.arrayBuffer(buffer, {
      headers: {
        'Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
    })
  }),
  http.get('api/Invoice/getInvoiceDocument', async () => {
    const buffer = await fetch('/mocks/invoice.pdf').then(response => response.arrayBuffer());
    await delay(1000);
    return HttpResponse.arrayBuffer(buffer, {
      headers: {
        'Content-Type':'application/pdf',
      }
    })
  })
);
